<!-- <app-header-one [sticky]="true"></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="terms-popup">
  <div class="popup-container">
      <div class="popup-card">

        <h1 class="title" style="cursor: pointer;">Pricing Policy</h1>

        <p><strong>Last Updated:</strong> 12th June, 2026</p>

            <h2>1. Introduction</h2>
            <p>
                This Pricing Policy outlines the terms and conditions for the pricing of services offered on NeoJobz Website and Mobile App (the "Application"). This policy is designed to provide transparency regarding the fees and charges associated with using the NeoJobz’s services, including but not limited to job postings, resume database access, featured listings, resume building, adverts, and subscription plans. The employers, vendors, or end-users’ discretion is requested in choosing the appropriate pricing plan for effective business results.
            </p>

            <h2>2. Pricing Structure</h2>

            <h3>2.1 Job Postings Fees</h3>
            <p>
                There are different job posting packages for different needs of different employers / vendors across various business sectors. It starts with a basic pricing plan, and the price increases with enhanced benefits.
            </p>

            <h3>2.2 Resume Database Access Fees</h3>
            <p>
                Resume Database packages for various employers / vendors across various industries. It starts with a basic Database access plan, and the price eventually increases with enhanced benefits.
            </p>

            <h3>2.3 Subscription Plans</h3>
            <p>
                There are different Subscription Plans such as Monthly, Bi-Monthly, Quarterly, Half-Yearly, Yearly or as the case may be for various employers / vendors pan India. It starts with a basic plan and increases with enhanced benefits.
            </p>

            <h3>2.4 Featured Employer Listings</h3>
            <p>
                Premium placement on the employer’s section of the portal, highlighted company profile, logo display etc. are features / advantages / benefits this plan offers to our clientele at large.
            </p>

            <h3>2.5 Advertising and Sponsorships</h3>
            <p>
                Banner Ads for a specific period of time lets display of banner ads on specific pages of the Portal. Likewise, Sponsored Job Listings highlights listing with priority in search results.
            </p>

           <h2>2.6 Pricing Policy For Jobseekers</h2>

            <h3>2.6.1 Free Services</h3>

            <p>
                Jobseekers can access certain features of the NeoJobz Application for free. These features include:
            </p>

            <p><strong>1.</strong> Browsing job listings</p>

            <p><strong>2.</strong> Creating and updating your profile</p>

            <p><strong>3.</strong> Applying for a limited number of jobs per month</p>

            <h3>2.6.2 Paid Services</h3>

            <p><strong>1. Resume Building:</strong> Build your desired resume on the go that suits your taste.</p>

            <p><strong>2. Resume Highlighting:</strong> Boost visibility by prioritizing your profile in recruiter searches.</p>

            <p><strong>3. Unlimited Job Applications:</strong> Apply to as many job listings as you like.</p>

            <p><strong>4. Access to Advanced Insights:</strong> View job application trends, salary data, and recruiter activity.</p>

            <p><strong>5. Direct Messaging:</strong> Contact recruiters directly via App.</p>

            <h3>2.6.3 Subscription Plans</h3>

            <p>
                There are various Subscription Plans such as Monthly, Bi-Monthly, Quarterly,
                Half-Yearly, Yearly or as the case may be for various profile uploads or profile
                seekers pan India. It starts with a basic plan and increases with enhanced benefits.
            </p>

            <h2>3. Payment Terms</h2>

            <h3>3.1 Payment Methods</h3>
            <p>
                Payments can be made via credit card, debit card, net banking, UPI, or any other payment methods accepted by our NeoJobz Application.
            </p>

            <h3>3.2 Billing Cycle</h3>
            <p>
                Payments for job postings and other services are due upfront at the time of purchase. Subscription plans will be billed according to the billing cycle selected (monthly, bi-monthly, quarterly, annually, or as the case may be).
            </p>

            <h3>3.3 Taxes</h3>
            <p>
                All prices are exclusive of applicable taxes, which will be added at checkout as per the prevailing tax laws.
            </p>

            <h3>3.4 Invoices</h3>
            <p>
                A digital invoice will be provided for all transactions to your emails or can be accessed from the user’s account dashboard.
            </p>

            <h3>3.5 For Jobseekers</h3>

            <p><strong>1.</strong> Payments of paid features are processed through your In-App Purchases.</p>

            <p><strong>2.</strong> Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current billing cycle.</p>

            <p><strong>3.</strong> Payment details are managed in <strong>Settings &gt; Your Name &gt; Subscriptions</strong> on your device.</p>

            <h2>4. Refund Policy</h2>

            <p>
                NeoJobz reserves the right to change the pricing of services at any time. Users will be notified of any changes to pricing at least 30 days in advance. Price changes will not affect any ongoing subscription or services purchased prior to the effective date of the price change.
            </p>

            <h2>5. Discounts and Promotions</h2>

            <h3>5.1 Promotions</h3>

            <p>
                From time to time, NeoJobz may offer promotions, discounts, or special pricing for certain services. These offers are subject to the terms and conditions specified in the promotion.
            </p>

            <h3>5.2 Bulk Discounts</h3>

            <p>
                Discounts on job postings, resume access, profile contacts, or profile uploads may be available for bulk purchases or large volume users. Please contact NeoJobz for more details.
            </p>

            <h2>6. Refund Policy</h2>

            <p><strong>6.1. Job Postings:</strong> No refunds will be issued for job postings once the job is live on the Portal.</p>

            <p><strong>6.2. Subscription Plans:</strong> Refunds for subscription plans will be considered on a case-by-case basis. Pro-rated refunds may be offered if the service is cancelled before the end of the subscription period.</p>

            <p><strong>6.3. Resume Access:</strong> No refunds will be issued for resume database access once resumes have been downloaded or accessed.</p>

            <p><strong>6.4. Resume Building:</strong> No refunds will be issued for resume building once the resume has been downloaded or accessed.</p>

            <p><strong>6.5. Advertising and Sponsorships:</strong> Refunds for advertising services are not permitted once the ad has been displayed or the campaign has started.</p>

            <h2>7. Cancellation Policy</h2>

            <p><strong>7.1. Subscription Services:</strong> Users can cancel their subscription at any time through their account settings. Cancellation will take effect at the end of the current billing cycle.</p>

            <p><strong>7.2. One-Time Purchases:</strong> One-time purchases (such as job postings, database access, resume building, etc.) cannot be cancelled once the transaction is completed.</p>

            <h2>8. Acceptance of Policy</h2>
            <p>
                By using the services offered by NeoJobz, users agree to the terms and conditions outlined in this Pricing Policy. If you do not agree with any part of this policy, please refrain from using the services.
            </p>

            <h2>9. Contact Information</h2>
            

             <p>
                For any questions or concerns regarding this Pricing Policy, please contact our support team at:
            </p>

            <p>
                <strong>By email:</strong>
                <a href="mailto:support@neojobz.com">
                    support&#64;neojobz.com
                </a>
            </p>

            <p>
                <strong>By phone number:</strong>
                +91-70 75 74 5784
            </p>

        </div>
    </div>
</section>

<app-footer-more-info></app-footer-more-info>

      <!-- <h2 class="title" >{{tncData.title}}</h2>
        <div [innerHTML]="tncData.description"></div> -->

      <!-- <div class="popup-card">
          <h2 class="title" style="cursor: pointer;">Pricing Policy</h2>
          <h3 style="text-align: center;">[Employment and Matrimonial Services]</h3>
          <p><strong>Effective Date:</strong> 14-Dec-2024 <span style="float: right;"><strong>Last Updated:</strong> 05-Feb-2025</span></p>

  
          <h2>1. Introduction</h2>
          <p>This Pricing Policy outlines the terms and conditions for the pricing of services offered on WhiteRobe (the "Application"). This policy is designed to provide transparency regarding the fees and charges associated with using the WhiteRobe’s Job Portal’s services, including but not limited to job postings, resume database access, featured listings, and subscription plans. The employers / vendors / endusers’ discretion is requested in choosing the appropriate pricing plan for effective business results.</p>
  
          <h2>2. Pricing Structure</h2>
  
          <h3><strong>2.1. Job Posting Fees</strong> </h3>
          <p>There are different job posting packages for different needs of employers/vendors across various business sectors. Pricing starts with a basic plan and increases with enhanced benefits.</p>
  
          <h3><strong>2.2. Resume Database Access</strong> </h3>
          <p>Resume Database packages are available for various employers/vendors across industries. Pricing starts with a basic access plan and increases with enhanced benefits.</p>
  
          <h3><strong>2.3. Subscription Plans</strong></h3>
          <p>There are different Subscription Planssuch as Monthly, Bi-Monthly, Quarterly, Half-Yearly, Yearly or as the case may befor variousemployers / vendors pan India. It starts with basic plan, and increases with enhanced benefits.</p>
  
          <h3><strong>2.4. Featured Employer Listings</strong></h3>
          <p>Premium placement on the employer’s section of the portal, highlighted company profile,logo display etc are features / advantages / benefits this plan offers to our clientele at large.</p>
  
          <h3><strong>2.5. Advertising and Sponsorships</strong></h3>
          <p>Banner Ads for a specific period of time lets display of banner ads on specific pages of the Portal.Likewise, Sponsored Job Listings highlights listing with priority in search results.</p>
  
          <h3><strong>2.6. Pricing Policy for Jobseekers is as below -</strong></h3>
         
              <p><strong>1.Free Features:</strong></p>
                <p>WhiteRobe provides basic features free of charge for jobseeekers, including:</p>
                 
                      <p>•	Browsing job listings</p>
                      <p>•	Creating and updating your profile</p>
                      <p>•	Applying for a limited number of jobs per month</p>

              <h3><strong>2.7.Paid Features:</strong></h3>
            
                <p>WhiteRobe offers premium subscriptions and add-on services to enhance your job search experience. Paid features may include:</p>
                  
                      <p><strong>•	Resume Highlighting:</strong> <span> Boost visibility by prioritizing your profile in recruiter searches.</span></p>
                      <p><strong>•	Unlimited Job Applications: </strong><span> Apply to as many job listings as you like.</span></p>
                      <p><strong>•	Access to Advanced Insights: </strong><span> View job application trends, salary data, and recruiter activity.</span></p>
                      <p><strong>•	Direct Messaging: </strong><span> Contact recruiters directly via the app.</span></p>
          
          <h3>With regard to Matrimony Services</h3>
         
              <p><strong>i.Free Features:</strong></p>
                <p>Basic access for end-users is free and includes:</p>
                  
                      <p>•	Browsing a limited number of profiles.</p>
                      <p>•	Creating and editing your profile.</p>
                      <p>•	Viewing basic profile information.</p>
                  
             
              
              <p><strong>ii.Paid Features:</strong></p>
                <p>Unlock premium features with a subscription:</p>
                  <ul>
                      <p><strong>Details Access:</strong><span> Access the contact details of profiles you’re interested in.</span> </p>
                      <p><strong>Profile Visibility Boost:</strong><span> Highlight your profile to get noticed by more users.</span></p>
                      <p><strong>Profile Visibility Boost:</strong><span> Use detailed filters (e.g., profession, location, family background etc).</span>x</p>
                      <p><strong>Direct Messaging:</strong><span> Communicate directly with potential matches.</span></p>
                  </ul>
            
              <p><strong>iii.Subscription Plans</strong></p>
                <p>There are variousSubscription Planssuch as Monthly, Bi-Monthly, Quarterly, Half-Yearly, Yearly or as the case may be for variousprofile uploads or profile seekerspan India. It starts with basic plan, and increases with enhanced benefits.</p>
                 
          <h2>3. Payment Terms</h2>
          <ul>
              <p><strong>3.1. Payment Methods:</strong> Payments can be made via credit card, debit card, net banking, UPI, or any other payment methods accepted by ourWhiteRobe Application.</p>
              <p><strong>3.2. Billing Cycle:</strong> Payments for job postings and other services are due upfront at the time of purchase. Subscription plans will be billed according to the billing cycle selected (monthly, bi-monthly, quarterly, annually, or as the case may be).</p>
              <p><strong>3.3.Taxes:</strong> All prices are exclusive of applicable taxes, which will be added at checkout as per the prevailing tax laws.</p>
              <p><strong>3.4. Invoices:</strong> A digital invoice will be provided for all transactions to your emails or can be accessed from the user’s account dashboard.</p>
              <p><strong>3.5. For Jobseekers or Matrimony Profile seekers: </strong> </p>
              <p>•	Payments of paid features are processed through your In-App-Purchases.</p>
              <p>•	Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current billing cycle.</p>
              <p>•	Payment details are managed in <strong> Settings > Your Name > Subscriptions</strong> on your device.</p>
          </ul>
  
          <h2>4. Changes to Pricing</h2>
          <p>WhiteRobe reserves the right to change the pricing of services at any time. Users will be notified of any changes to pricing at least 30 days in advance. Price changes will not affect any ongoing subscription or services purchased prior to the effective date of the price change.</p>  
          <h2>5. Discounts and Promotions</h2>
          <ul>
            <p><strong>5.1. Promotions:</strong>
              From time to time, WhiteRobe may offer promotions, discounts, or special pricing for certain services. These offers are subject to the terms and conditions specified in the promotion.
            </p>
            <p><strong>5.2. Bulk Discounts:</strong>
              Discounts on job postings, resume access, profile contacts, or profile uploads may be available for bulk purchases or large volume users. Please contact WhiteRobe for more details.
            </p>
              
          </ul>
  
          <h2>6. Refund Policy</h2>
          <ul>
            <p><strong>6.1. Job Postings or Profile Uploads:</strong>
              No refunds will be issued for job postings once the job is live on the Portal,or bride & groom profiles are uploaded.
            </p>
            <p><strong>6.2. Subscription Plans:</strong>
             Refunds for subscription plans will be considered on a case-by-case basis. Pro-rated refunds may be offered if the service is cancelled before the end of the subscription period.
            </p>
            <p><strong>6.3. Resume Access:</strong>
              No refunds will be issued for resume database access once resumes have been downloaded,or when matrimony profile contact details are accessed.
            </p>
            <p><strong>6.4. Advertising and Sponsorships:</strong>
               Refunds for advertising services are not permitted once the ad has been displayed or the campaign has started.
            </p>
              
          </ul>
  
          <h2>7. Cancellation Policy</h2>
          <ul>
            <p><strong>7.1. Subscription Services:</strong>
              Users can cancel their subscription at any time through their account settings. Cancellation will take effect at the end of the current billing cycle.
           </p>
           <p><strong>7.2. One-Time Purchases:</strong>
            One-time purchases (such as job postings or profile contacts etc.) cannot be cancelled once the transaction is completed.
         </p>
          </ul>
  
          <h2>8. Acceptance of Policy</h2>
          <p>•	By using the services offered by WhiteRobe, users agree to the terms and conditions outlined in this Pricing Policy. If you do not agree with any part of this policy, please refrain from using the services.</p>
  
          <h2>9. Contact Information</h2>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <p>•	For any questions or concerns regarding this Pricing Policy, please contact our support team at:</p>
    <ul >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong>Email:</strong> <a href="mailto:support&#64;whiterobe.in"> support&#64;whiterobe.in</a></li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong>Phone:</strong> +91-70 75 85 5784</li><br>
    </ul>
      </div> -->
  
<!-- <app-footer-one></app-footer-one> -->


        




